/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {GrowthModelOverride} from '../bioplanModels';
// @ts-ignore
import type {GrowthModelOverrideDetailed} from '../bioplanModels';
/**
 * ModellingGrowthModelOverridesApi - axios parameter creator
 * @export
 */
export const ModellingGrowthModelOverridesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelOverridesGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('growthModelOverridesGet', 'planId', planId);
      const localVarPath = `/growthModelOverrides/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete growth model override by its identifier
     * @param {string} growthModelOverrideId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelOverridesGrowthModelOverrideIdDelete: async (
      growthModelOverrideId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'growthModelOverrideId' is not null or undefined
      assertParamExists(
        'growthModelOverridesGrowthModelOverrideIdDelete',
        'growthModelOverrideId',
        growthModelOverrideId,
      );
      const localVarPath = `/growthModelOverrides/{growthModelOverrideId}`.replace(
        `{${'growthModelOverrideId'}}`,
        encodeURIComponent(String(growthModelOverrideId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new growth model override
     * @param {GrowthModelOverride} growthModelOverride
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelOverridesPost: async (
      growthModelOverride: GrowthModelOverride,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'growthModelOverride' is not null or undefined
      assertParamExists('growthModelOverridesPost', 'growthModelOverride', growthModelOverride);
      const localVarPath = `/growthModelOverrides/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(growthModelOverride, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ModellingGrowthModelOverridesApi - functional programming interface
 * @export
 */
export const ModellingGrowthModelOverridesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ModellingGrowthModelOverridesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async growthModelOverridesGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GrowthModelOverrideDetailed>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.growthModelOverridesGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingGrowthModelOverridesApi.growthModelOverridesGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete growth model override by its identifier
     * @param {string} growthModelOverrideId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async growthModelOverridesGrowthModelOverrideIdDelete(
      growthModelOverrideId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.growthModelOverridesGrowthModelOverrideIdDelete(
        growthModelOverrideId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingGrowthModelOverridesApi.growthModelOverridesGrowthModelOverrideIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create a new growth model override
     * @param {GrowthModelOverride} growthModelOverride
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async growthModelOverridesPost(
      growthModelOverride: GrowthModelOverride,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrowthModelOverride>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.growthModelOverridesPost(growthModelOverride, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingGrowthModelOverridesApi.growthModelOverridesPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ModellingGrowthModelOverridesApi - factory interface
 * @export
 */
export const ModellingGrowthModelOverridesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ModellingGrowthModelOverridesApiFp(configuration);
  return {
    /**
     *
     * @param {ModellingGrowthModelOverridesApiGrowthModelOverridesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelOverridesGet(
      requestParameters: ModellingGrowthModelOverridesApiGrowthModelOverridesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<GrowthModelOverrideDetailed>> {
      return localVarFp
        .growthModelOverridesGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete growth model override by its identifier
     * @param {ModellingGrowthModelOverridesApiGrowthModelOverridesGrowthModelOverrideIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelOverridesGrowthModelOverrideIdDelete(
      requestParameters: ModellingGrowthModelOverridesApiGrowthModelOverridesGrowthModelOverrideIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .growthModelOverridesGrowthModelOverrideIdDelete(requestParameters.growthModelOverrideId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new growth model override
     * @param {ModellingGrowthModelOverridesApiGrowthModelOverridesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    growthModelOverridesPost(
      requestParameters: ModellingGrowthModelOverridesApiGrowthModelOverridesPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GrowthModelOverride> {
      return localVarFp
        .growthModelOverridesPost(requestParameters.growthModelOverride, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for growthModelOverridesGet operation in ModellingGrowthModelOverridesApi.
 * @export
 * @interface ModellingGrowthModelOverridesApiGrowthModelOverridesGetRequest
 */
export interface ModellingGrowthModelOverridesApiGrowthModelOverridesGetRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingGrowthModelOverridesApiGrowthModelOverridesGet
   */
  readonly planId: string;
}

/**
 * Request parameters for growthModelOverridesGrowthModelOverrideIdDelete operation in ModellingGrowthModelOverridesApi.
 * @export
 * @interface ModellingGrowthModelOverridesApiGrowthModelOverridesGrowthModelOverrideIdDeleteRequest
 */
export interface ModellingGrowthModelOverridesApiGrowthModelOverridesGrowthModelOverrideIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof ModellingGrowthModelOverridesApiGrowthModelOverridesGrowthModelOverrideIdDelete
   */
  readonly growthModelOverrideId: string;
}

/**
 * Request parameters for growthModelOverridesPost operation in ModellingGrowthModelOverridesApi.
 * @export
 * @interface ModellingGrowthModelOverridesApiGrowthModelOverridesPostRequest
 */
export interface ModellingGrowthModelOverridesApiGrowthModelOverridesPostRequest {
  /**
   *
   * @type {GrowthModelOverride}
   * @memberof ModellingGrowthModelOverridesApiGrowthModelOverridesPost
   */
  readonly growthModelOverride: GrowthModelOverride;
}

/**
 * ModellingGrowthModelOverridesApi - object-oriented interface
 * @export
 * @class ModellingGrowthModelOverridesApi
 * @extends {BaseAPI}
 */
export class ModellingGrowthModelOverridesApi extends BaseAPI {
  /**
   *
   * @param {ModellingGrowthModelOverridesApiGrowthModelOverridesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingGrowthModelOverridesApi
   */
  public growthModelOverridesGet(
    requestParameters: ModellingGrowthModelOverridesApiGrowthModelOverridesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingGrowthModelOverridesApiFp(this.configuration)
      .growthModelOverridesGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete growth model override by its identifier
   * @param {ModellingGrowthModelOverridesApiGrowthModelOverridesGrowthModelOverrideIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingGrowthModelOverridesApi
   */
  public growthModelOverridesGrowthModelOverrideIdDelete(
    requestParameters: ModellingGrowthModelOverridesApiGrowthModelOverridesGrowthModelOverrideIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingGrowthModelOverridesApiFp(this.configuration)
      .growthModelOverridesGrowthModelOverrideIdDelete(requestParameters.growthModelOverrideId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new growth model override
   * @param {ModellingGrowthModelOverridesApiGrowthModelOverridesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingGrowthModelOverridesApi
   */
  public growthModelOverridesPost(
    requestParameters: ModellingGrowthModelOverridesApiGrowthModelOverridesPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingGrowthModelOverridesApiFp(this.configuration)
      .growthModelOverridesPost(requestParameters.growthModelOverride, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
